import { ReportModalConfig } from '@features/siteStatusV2/components/reports/types/commun';
import { ComplaintReport } from '@features/siteStatusV2/types';
import {
  BoxFill,
  Clipboard2Fill,
  ClockFill,
  FileEarmarkTextFill,
  RssFill
} from 'react-bootstrap-icons';
import { getI18n } from 'react-i18next';

import AssociatedTickets from '../AssociatedTickets';
import {
  MapIncidentTypeStatusToDisplay,
  MapInterventionStatusToDisplay,
  MapProcesssingTypeStatusToDisplay,
  MapReportTypeStatusToDisplay
} from '../maps';
import { TranslationNamespaces } from '../../../../../locales/constants/translationNamespaces.enum';

const createComplaintModalConfig = (report: ComplaintReport): ReportModalConfig => {
  const { t } = getI18n();
  return {
    header: {
      title: `${t('report.title', {
        ns: TranslationNamespaces.SITE_STATUS
      })} - ${t('report.complaint', {
        ns: TranslationNamespaces.SITE_STATUS
      })}`,
      ticketId: report.ticketNumber,
      status: report.status,
      creationDate: report.creationDate
    },
    sections: [
      {
        title: t('report.generalInformation', {
          ns: TranslationNamespaces.SITE_STATUS
        }),
        fields: [
          {
            label: t('report.serviceReference', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: report.serviceReference,
            icon: <BoxFill />,
            badge: {
              color: 'grey',
              full: true
            }
          },
          {
            label: t('report.reportType.label', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: t(MapReportTypeStatusToDisplay[report.reportType], {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            icon: <Clipboard2Fill />,
            badge: {
              color: 'grey',
              full: true
            }
          },
          {
            label: t('report.incidentStartDate', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: report.incidentStartDate,
            type: 'date',
            icon: <ClockFill />,
            badge: {
              color: 'grey',
              full: true
            }
          }
        ]
      },
      {
        title: t('report.report', {
          ns: TranslationNamespaces.SITE_STATUS
        }),
        fields: [
          {
            label: t('report.incidentType.label', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: t(MapIncidentTypeStatusToDisplay[report.incidentType], {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            icon: <Clipboard2Fill />
          },
          {
            label: t('report.processingType.label', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: t(MapProcesssingTypeStatusToDisplay[report.processingType], {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            icon: <FileEarmarkTextFill />
          }
        ]
      },
      {
        title: `${t('report.listTicketAssociated', {
          ns: TranslationNamespaces.SITE_STATUS
        })} (${report.associatedTickets.length})`,
        custom: <AssociatedTickets ids={report.associatedTickets} />
      },
      {
        title: t('report.intervention', {
          ns: TranslationNamespaces.SITE_STATUS
        }),
        fields: [
          {
            label: t('report.interventionCreationDate', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: report.interventionCreationDate,
            type: 'date',
            icon: <ClockFill />,
            badge: {
              color: 'grey',
              full: true
            }
          },
          {
            label: t('report.interventionStartDate', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: report.interventionStartDate,
            type: 'date',
            icon: <ClockFill />,
            badge: {
              color: 'grey',
              full: true
            }
          },
          {
            label: t('report.interventionStatus.label', {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            value: t(MapInterventionStatusToDisplay[report.interventionStatus], {
              ns: TranslationNamespaces.SITE_STATUS
            }),
            icon: <RssFill />
          }
        ]
      }
    ]
  };
};

export default createComplaintModalConfig;
